import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import * as actions from '../actions/truck';
import { LoadShipmentGroupInput } from '../../models/truck';

export function useTrucks() {
  const dispatch = useDispatch();

  const loadShipmentGroup = useCallback(
    (data: LoadShipmentGroupInput) => dispatch(actions.loadShipmentGroup.request(data)),
    [dispatch],
  );

  return {
    loadShipmentGroup,
  };
}
